(ns common.schema.entities.rotation-period.core
  (:require
   [common.schema.entities.rotation-period.permissions :as permissions]
   [common.schema.entities.rotation-period.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/rotation-period
   :schema                       schema/schema
   :name                         {:en "Rotation period"}
   :plural                       {:en "Rotation periods"}
   :icon                         :fa-repeat
   :display-name-template        "{{rotation-period/rotation-period-label}}"
   :display-name/depends-on      [:rotation-period/rotation-period-label]
   ;; Indexing is declared in common.opensearch.entity-indices, beside the
   ;; other survey types, rather than as a `:search` block here. The two are
   ;; merged into the same config, but a `:search` block also marks the type as
   ;; having a listing - and a listing is required to resolve a non-empty set
   ;; of default export columns, which a rotation period has none of. It has no
   ;; grid of its own; it is edited from the survey type's detail panel.
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
